import { differenceWith, isEqual } from 'lodash';
export function deepDiff(modified, initial) {
    return Object.fromEntries(differenceWith(Object.entries(modified), Object.entries(initial), isEqual));
}
